<div class="ktbl-spacer-top-bottom"></div>

<div class="ktbl-container">
  <h3>Ergebnisse der Abstandsberechnung</h3>

  <div class="ktbl-scrollable-table">
    <table mat-table [dataSource]="dataErgebnisBerechnungenList" class="ktbl-table-breite-komplett">
      <ng-container *ngFor="let column of displayedColsErgebnisBerechnungenList; let j = index" [matColumnDef]="column">
        <th mat-header-cell *matHeaderCellDef [ngClass]="{
              'ktbl-table-header-base-links': j === 0,
              'ktbl-table-header-base-neutral ': j !== 0 && j !== (displayedColsErgebnisBerechnungenList.length - 1),
              'ktbl-table-header-base-rechts': j === (displayedColsErgebnisBerechnungenList.length - 1),
              'ktbl-table-header-typografie' : true,
              'ktbl-table-allgemein-125-width': column === 'ZUSATZABSTAND',              
              'ktbl-table-allgemein-150-width': column === 'GESAMTEMISSION',
              'ktbl-table-allgemein-175-width': column === 'EMISSIONSSCHWERPUNKT_X' || column === 'EMISSIONSSCHWERPUNKT_Y',
              'ktbl-table-allgemein-300-width': column === 'BEZEICHNUNG',

 
            'ktbl-excel-pdf-export-width': column === 'DOWNLOAD_EXCEL_PDF_EXPORT'            
            }">
          <ng-container *ngIf="column === 'BEZEICHNUNG'">Projektname</ng-container>
          <ng-container *ngIf="column === 'BESCHREIBUNG'">Beschreibung</ng-container>
          <ng-container *ngIf="column === 'GESAMTEMISSION'">
            Gesamtemission in GE/s

            <i class="fas fa-info-circle ktbl-icon-info-select" [matTooltip]="
      'Eine Geruchsstoffemission bis zu '
      + (maxGesamtemissionGeS | number:'1.0-0':'de-DE')
      + ' GE/s ist von der Richtlinie VDI 3894 Blatt 2 abgedeckt. Bei stärkeren Emissionen sind die Ergebnisse als Anhaltswerte zu betrachten.'
    " matTooltipClass="tooltip-format" [matTooltipPosition]="tooltipPosition.value">
            </i>
          </ng-container>
          <ng-container *ngIf="column === 'EMISSIONSSCHWERPUNKT_X'"> Emissionsschwerpunkt X<sub>ES</sub> in
            m</ng-container>
          <ng-container *ngIf="column === 'EMISSIONSSCHWERPUNKT_Y'"> Emissionsschwerpunkt Y<sub>ES</sub> in
            m</ng-container>
          <ng-container *ngIf="column === 'ZUSATZABSTAND'">Zusatzabstand d in m </ng-container>
          <ng-container *ngIf="column === 'DOWNLOAD_EXCEL_PDF_EXPORT'">Download</ng-container>
        </th>

        <td mat-cell *matCellDef="let entry; let i = index" [ngClass]="{
            'ktbl-table-content-normal': i % 2 === 0,
            'ktbl-table-content-invert': i % 2 !== 0,
            'ktbl-table-content-border': j === 0,            
            'ktbl-table-cell-right': column === 'GESAMTEMISSION' || column === 'EMISSIONSSCHWERPUNKT_X' || column === 'EMISSIONSSCHWERPUNKT_Y' || column === 'ZUSATZABSTAND',
            'ktbl-table-cell-left': column === 'BEZEICHNUNG' || column === 'BESCHREIBUNG',
            'ktbl-table-cell-no-padding-right': column === 'DOWNLOAD_EXCEL_PDF_EXPORT'
            }">
          <ng-container *ngIf="column === 'BEZEICHNUNG'">{{ entry.bezeichnung }} </ng-container>
          <ng-container *ngIf="column === 'BESCHREIBUNG'">{{ entry.beschreibung }} </ng-container>
          <ng-container *ngIf="column === 'GESAMTEMISSION'">
            <span [style.color]="
              entry.ergebnisQuelleGes.gesamtemissionen > maxGesamtemissionGeS
                ? GlobalConstantsColor.RED
                : null">
              {{
              entry.ergebnisQuelleGes.gesamtemissionen
              | number : "1.0-0" : "de-DE"
              }}
            </span>
          </ng-container>
          <ng-container *ngIf="column === 'EMISSIONSSCHWERPUNKT_X'"> {{ entry.ergebnisQuelleGes.emissionsschwerpunktX
            }}</ng-container>
          <ng-container *ngIf="column === 'EMISSIONSSCHWERPUNKT_Y'"> {{ entry.ergebnisQuelleGes.emissionsschwerpunktY
            }}</ng-container>
          <ng-container *ngIf="column === 'ZUSATZABSTAND'">
            {{
            entry.ergebnisQuelleGes.zusatzabstand
            | number : "1.1-1" : "de-DE"
            }}
          </ng-container>
          <ng-container *ngIf="column === 'DOWNLOAD_EXCEL_PDF_EXPORT'">
            <div class="ktbl-button-container-zentriert">
              <button class="ktbl-button-tertiaer ktbl-button-icon-s" type="button" matTooltip="PDF-Download"
                (click)="onClickDownloadPdf()" [matTooltipPosition]="tooltipPosition.value"
                matTooltipClass="tooltip-format"> <i class="fas fa-file-pdf ktbl-icon-vertical-align"></i></button>
              <button class="ktbl-button-tertiaer ktbl-button-icon-s" type="button" matTooltip="Excel-Download"
                (click)="onClickDownloadExcel()" [matTooltipPosition]="tooltipPosition.value"
                matTooltipClass="tooltip-format"> <i class="fas fa-file-excel ktbl-icon-vertical-align"></i></button>
              <button class="ktbl-button-tertiaer ktbl-button-icon-s" type="button" matTooltip="Betrieb exportieren"
                (click)="onClickExportBetrieb()" [matTooltipPosition]="tooltipPosition.value"
                matTooltipClass="tooltip-format"> <i class="fas fa-file-export ktbl-icon-vertical-align"></i></button>
            </div>

          </ng-container>

      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColsErgebnisBerechnungenList"></tr>
      <tr mat-row *matRowDef="
            let row;
            columns: displayedColsErgebnisBerechnungenList
          "></tr>
    </table>
  </div>
  <div class="ktbl-spacer-top-bottom"></div>

  <mat-accordion class="ktbl-example-headers-align" multi>
    <mat-expansion-panel class="ktbl-accordeon-margin-top" hideToggle="true" #panel1>
      <mat-expansion-panel-header>
        <mat-panel-title class="ktbl-mat-expension-panel-title">
          <span class="ktbl-expansion-panel-padding">Detailansicht</span>

          <div style="margin-left: auto;">
            <i *ngIf="!panel1.expanded" class="fa-solid fa-circle-caret-down ktbl-icon-mat-expansion"></i>
            <i *ngIf="panel1.expanded" class="fa-solid fa-circle-caret-up ktbl-icon-mat-expansion"></i>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div class="ktbl-spacer-top-bottom"></div>
      <div class="ktbl-row-mehrspaltig-2-elemente">


        <h3 class="ktbl-img-center">Windhäufigkeit in ‰ nach Windrichtung in °
        </h3>
        <h3 class="ktbl-img-center">Mindestabstand R' in m nach Windrichtung in °</h3>


      </div>
      <div class="ktbl-row-mehrspaltig-2-elemente">


        <img id="picWindhaeufigkeit" class="ktbl-img-center" [src]="picWindhaeufigkeit" />




        <img id="picMindestabstand" class="ktbl-img-center" [src]="picMindestabstand" />



      </div>
      <div class="ktbl-spacer-top-bottom"></div>

    </mat-expansion-panel>

    <mat-expansion-panel class="ktbl-accordeon-margin-top" hideToggle="true" #panel2>
      <mat-expansion-panel-header>
        <mat-panel-title class="ktbl-mat-expension-panel-title">
          <span class="ktbl-expansion-panel-padding">Windhäufigkeit und Richtlinienabstand</span>

          <div style="margin-left: auto;">
            <i *ngIf="!panel2.expanded" class="fa-solid fa-circle-caret-down ktbl-icon-mat-expansion"></i>
            <i *ngIf="panel2.expanded" class="fa-solid fa-circle-caret-up ktbl-icon-mat-expansion"></i>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>


      <div class="ktbl-scrollable-table">
        <table mat-table [dataSource]="dataErgebnisWindRichtlinienabList" class="ktbl-table-breite-komplett">
          <ng-container *ngFor="let column of displayedColsErgebnisWindRichtlinienab; let j = index"
            [matColumnDef]="column">
            <th mat-header-cell *matHeaderCellDef [ngClass]="{
            'ktbl-table-allgemein-200-width': column !== 'GEBIETSKATEGORIE' && column !== 'RM' && column !== 'RM_STRICH',
            'ktbl-table-allgemein-100-width': column === 'RM' || column === 'RM_STRICH',
            'ktbl-sub-table-header-base-neutral': true,
            'ktbl-typografie-reg-14-zwischenueberschrift': true,
            'ktbl-windrichtung-transportrichtung-beschreibung-width': column === 'WINDRICHTUNG_TRANSPORTRICHTUNG_BESCHREIBUNG'           
            }">
              <ng-container
                *ngIf="column === 'WINDRICHTUNG_TRANSPORTRICHTUNG_BESCHREIBUNG'">Wind-/Transportrichtung</ng-container>

              <ng-container *ngIf="column === 'WINDHAEUFIGKEIT'">Windhäufigkeit in ‰
                <i class="fas fa-info-circle ktbl-icon-info-select"
                  matTooltip="Windhäufigkeiten von bis zu 60 ‰ (bei einer 36-teiligen Windrose) sind von der Richtlinie VDI 3894 Blatt 2 abgedeckt. Bei größeren Windhäufigkeiten sind die Ergebnisse als Anhaltswerte zu betrachten und werden in roter Schrift hervorgehoben."
                  matTooltipClass="tooltip-format" [matTooltipPosition]="tooltipPosition.value">
                </i>


              </ng-container>
              <ng-container *ngIf="column === 'GEBIETSKATEGORIE'">Gebietskategorie</ng-container>
              <ng-container *ngIf="column === 'ZUL_GERUCHSTUND_GIRL'">Zulässige Geruchsstundenhäufigkeit nach Anhang 7
                TA Luft in %</ng-container>
              <ng-container *ngIf="column === 'RM'">R in m
                <i class="fas fa-info-circle ktbl-icon-info-select"
                  matTooltip="Richtlinienabstand in m; Werte außerhalb des Geltungsbereichs der Richtlinie (Abstände < 50 m) sind in roter Schrift hervorgehoben; dies gilt auch für Abstände, die auf 50 m aufgerundet wurden."
                  matTooltipClass="tooltip-format" [matTooltipPosition]="tooltipPosition.value">
                </i>

              </ng-container>
              <ng-container *ngIf="column === 'GEWICHTUNGSFAKTOR'"> Gewichtungsfaktor nach Anhang 7 TA
                Luft</ng-container>
              <ng-container *ngIf="column === 'RM_STRICH'">R' in m
                <i class="fas fa-info-circle ktbl-icon-info-select"
                  matTooltip="Richtlinienabstand in m unter Berücksichtigung des Gewichtungsfaktors; Werte außerhalb des Geltungsbereichs der Richtlinie (Abstände < 50 m) sind in roter Schrift hervorgehoben; dies gilt auch für Abstände, die auf 50 m aufgerundet wurden."
                  matTooltipClass="tooltip-format" [matTooltipPosition]="tooltipPosition.value">
                </i>

              </ng-container>

            </th>

            <td mat-cell *matCellDef="let entry; let i = index" [ngClass]="{
            'ktbl-table-content-normal': i % 2 === 0,
            'ktbl-table-content-invert': i % 2 !== 0,
            'ktbl-table-content-border': j === 0,            
            'ktbl-table-cell-left': column === 'WINDRICHTUNG_TRANSPORTRICHTUNG_BESCHREIBUNG' || column === 'GEBIETSKATEGORIE', 
            'ktbl-table-cell-right': column !== 'WINDRICHTUNG_TRANSPORTRICHTUNG_BESCHREIBUNG' && column !== 'GEBIETSKATEGORIE' 
            }">
              <ng-container *ngIf="column === 'WINDRICHTUNG_TRANSPORTRICHTUNG_BESCHREIBUNG'">
                {{ entry.windrichtung }}°/{{ entry.transportrichtung }}°
                <ng-container *ngIf="(entry.beschreibung ?? '').trim().length">
                  ({{ entry.beschreibung }})
                </ng-container>
              </ng-container>

              <ng-container *ngIf="column === 'WINDHAEUFIGKEIT'">
                <span [class.ktbl-error-color]="entry.windhaeufigkeit == null || entry.windhaeufigkeit > 60">
                  {{ entry.windhaeufigkeit | number:"1.0-0":"de-DE" }}
                </span>
              </ng-container>

              <ng-container *ngIf="column === 'GEBIETSKATEGORIE'">
                {{ getGebietskategorieText(entry.idGebietskategorie) }}
              </ng-container>

              <ng-container *ngIf="column === 'ZUL_GERUCHSTUND_GIRL'">
                <span
                  [class.ktbl-error-color]="entry.richtlinienabstandUnbewertet == null || entry.richtlinienabstandUnbewertet < 50">
                  {{
                  entry.richtlinienabstandUnbewertet == null
                  ? '-'
                  : (entry.hg | number:'1.1-1':'de-DE')
                  }}
                </span>
              </ng-container>

              <ng-container *ngIf="column === 'RM'">
                <span
                  [class.ktbl-error-color]="entry.richtlinienabstandUnbewertet == null || entry.richtlinienabstandUnbewertet < 50">
                  {{
                  entry.richtlinienabstandUnbewertet == null
                  ? '-'
                  : (entry.richtlinienabstandUnbewertet | number:'1.0-0':'de-DE')
                  }}
                </span>
              </ng-container>

              <ng-container *ngIf="column === 'GEWICHTUNGSFAKTOR'">
                <span
                  [class.ktbl-error-color]="entry.richtlinienabstandBewertet == null || entry.richtlinienabstandBewertet < 50">
                  {{
                  entry.gewichtungsfaktor == null
                  ? '-'
                  : (entry.gewichtungsfaktor | number:'1.2-2':'de-DE')
                  }}
                </span>
              </ng-container>

              <ng-container *ngIf="column === 'RM_STRICH'">
                <span
                  [class.ktbl-error-color]="entry.richtlinienabstandBewertet == null || entry.richtlinienabstandBewertet < 50">
                  {{
                  entry.richtlinienabstandUnbewertet == null
                  ? '-'
                  : (entry.richtlinienabstandBewertet | number:'1.0-0':'de-DE')
                  }}
                </span>
              </ng-container>

          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColsErgebnisWindRichtlinienab"></tr>
          <tr mat-row *matRowDef="
            let row;
            columns: displayedColsErgebnisWindRichtlinienab
          "></tr>
        </table>
      </div>
    </mat-expansion-panel>















  </mat-accordion>

  <div class="ktbl-spacer-top-bottom"></div>


  <div class="ktbl-button-container">
    <div class="ktbl-button-container-left">
      <button (click)="zuMainSeite()" class="ktbl-button-primaer ktbl-button-width-m" type="button">
        <i class="fas fa-arrow-left ktbl-icon-vertical-align"></i>
        Zurück
      </button>
    </div>

    <div class="ktbl-button-container-right">
    </div>
  </div>
</div>
<div class="ktbl-spacer-top-bottom"></div>


<div class="ktbl-floating-container-ohne-rand-wrapper">
  <div class="ktbl-floating-content">
    <button (click)="zuMainSeite()" mat-raised-button class="ktbl-button-primaer ktbl-button-icon-l" type="button"
      matTooltip="Zurück" [matTooltipPosition]="tooltipPosition.value" matTooltipClass="tooltip-format">
      <i class="fas fa-arrow-left ktbl-icon-vertical-align"></i>
    </button>

    <button (click)="onClickUp()" mat-raised-button class="ktbl-button-primaer ktbl-button-icon-l" type="button">
      <i class="fas fa-chevron-up ktbl-icon-vertical-align"></i>
    </button>

    <button (click)="onClickDown()" mat-raised-button class="ktbl-button-primaer ktbl-button-icon-l" type="button">
      <i class="fas fa-chevron-down ktbl-icon-vertical-align"></i>
    </button>
  </div>
</div>